export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14663.d8c2dd07.jpg";